import React, { useEffect, useState } from 'react';
import useFetch from '../../hooks/useFetch';
import TemplateService from '../../services/template-service';
import './AudioPlayer.module.scss';
import LoadingMessage from '../LoadingMessage';

const noop = async () => {};

const AudioPlayer = ({ text, src, type = 'audio/mp3' }) => {
  const { data, loading } = useFetch(src ? noop : TemplateService.getAudioTemplatePreview, text, {
    suspense: false,
  });
  const [file, setFile] = useState(null);

  useEffect(() => {
    if (data) {
      const src = URL.createObjectURL(data);
      setFile(`${src}`);

      return () => {
        URL.revokeObjectURL(src);
      };
    } else setFile(null);
  }, [data]);

  const toPlay = src || file;

  if (!toPlay || loading) return <LoadingMessage />;

  return (
    <audio controls style={{ minWidth: '350px' }}>
      <source src={toPlay} type={type} />
      Your browser does not support the audio element.
    </audio>
  );
};

export default AudioPlayer;
